import Vue from 'vue';
import VeeValidate from 'vee-validate';

const dictionary = {
    en: {
        messages:{
            numeric: () => 'This field can only contain numeric characters.'
        }
    }
};

Vue.use(VeeValidate);


// WEBPACK FOOTER //
// ./src/plugins/validate.js